import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useLogout from "src/hooks/useLogout";



const Logout: FC = () : JSX.Element => {
  const { logoutUser } = useLogout()
  const navigate = useNavigate()

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (token)
      logoutUser()
    else
      navigate("/users/sign_in")

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // useEffect(() => {
  //   console.log({userData})
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  return <></>;
}

export default Logout
